/*
 * Copyright 2022. NXGN Management, LLC. All Rights Reserved.
 */

import { Component, Input } from "@angular/core";
import { Merchant } from "../../../models";

@Component({
  selector: "app-customer-contact",
  templateUrl: "./customer-contact.component.html"
})
export class CustomerContactComponent {
  @Input("merchant") merchant!: Merchant;
}
